import React, { Component } from "react";
import { Link } from "react-router-dom";

class MegaMenuMobile extends Component {

    render() {

        return (
            <div className="accordionMenuDivMobile">

                <div className="accordionMenuDivInsideMobile">

                    {/* ================================
                        MENU HEADER
                    ================================= */}
                    <div className="mobileMenuHeader">

                        <span className="mobileMenuHeaderIcon">
                            <i className="fa fa-car"></i>
                        </span>

                        <div>
                            <h5>Prime Luxury</h5>
                            <span>Passenger Transport</span>
                        </div>

                    </div>


                    {/* ================================
                        HOME
                    ================================= */}
                    <Link
                        to="/"
                        className="mobileMenuLink"
                    >

                        <span className="mobileMenuIcon">
                            <i className="fa fa-home"></i>
                        </span>

                        <span className="mobileMenuText">
                            Home
                        </span>

                        <span className="mobileMenuArrow">
                            <i className="fa fa-angle-right"></i>
                        </span>

                    </Link>


                    {/* ================================
                        CONTACT US
                    ================================= */}
                    <Link
                        to="/contact-us"
                        className="mobileMenuLink"
                    >

                        <span className="mobileMenuIcon">
                            <i className="fa fa-phone"></i>
                        </span>

                        <span className="mobileMenuText">
                            Contact Us
                        </span>

                        <span className="mobileMenuArrow">
                            <i className="fa fa-angle-right"></i>
                        </span>

                    </Link>


                    {/* ================================
                        CONTACT INFORMATION
                    ================================= */}
                    <div className="mobileMenuContactBox">

                        <div className="mobileMenuContactTitle">
                            Contact Us
                        </div>


                        {/* PHONE */}
                        <a
                            href="tel:+971501011783"
                            className="mobileContactItem"
                        >

                            <span className="mobileContactItemIcon">
                                <i className="fa fa-phone"></i>
                            </span>

                            <span className="mobileContactItemContent">

                                <small>Call Us</small>

                                <strong>
                                    +971 50 101 1783
                                </strong>

                            </span>

                            <i className="fa fa-angle-right mobileContactArrow"></i>

                        </a>


                        {/* EMAIL */}
                        <a
                            href="mailto:booking@dxblimo.com"
                            className="mobileContactItem"
                        >

                            <span className="mobileContactItemIcon">
                                <i className="fa fa-envelope"></i>
                            </span>

                            <span className="mobileContactItemContent">

                                <small>Email Us</small>

                                <strong>
                                    booking@dxblimo.com
                                </strong>

                            </span>

                            <i className="fa fa-angle-right mobileContactArrow"></i>

                        </a>


                        {/* WHATSAPP */}
                        <a
                            href="https://wa.me/971501011783"
                            className="mobileContactItem"
                            target="_blank"
                            rel="noopener noreferrer"
                        >

                            <span className="mobileContactItemIcon">
                                <i className="fab fa-whatsapp"></i>
                            </span>

                            <span className="mobileContactItemContent">

                                <small>WhatsApp</small>

                                <strong>
                                    Chat with us
                                </strong>

                            </span>

                            <i className="fa fa-angle-right mobileContactArrow"></i>

                        </a>

                    </div>


                    {/* ================================
                        FOOTER
                    ================================= */}
                    <div className="mobileMenuFooter">

                        <span>
                            Premium Chauffeur Services
                        </span>

                        <div className="mobileMenuFooterLine"></div>

                        <small>
                            Dubai · UAE
                        </small>

                    </div>

                </div>

            </div>
        );
    }
}

export default MegaMenuMobile;